import React from 'react'

const Thirty_four = () => {
    return (
        <div className='container'>
            <h1>Selection Sort</h1>
           
          <p>The selection Sort is assaulting algorithm that works bye buy a finding 
            the smallest number from the array and then placing it to the first
             position. the next array that is to be traversed will start from index 
             next to the position where the smallest number is placed. <br />
              Example: <br />
              We have an array &#123;6, 3, 8, 12, 9&#125; in this array the smallest 
              element is 3. So we will place 3 at the first position, after this the array 
              will look like &#123;3, 6, 8, 12, 9 &#123;. Now we will again find the smallest number
               but this time we will not consider 3 in our search because it is in its 
               place. Finding the next smallest element that is 6, creating an array 
               with 6 at the second position and then again searching in the array till
                the array is sorted.
          </p>  
            <h3>Working of Algorithm</h3>
            Let's take an array &#123;20, 12 , 23, 55 ,21&#125;<br />
            <ol>
                <li>Set the first element of the array as minimum. <br /> Minimum = 20</li>
                <li>Compare the minimum with the next element, if it is smaller than 
                    minimum assign this element as minimum. Do this till the end of the 
                    array.<br />

Comparing with 12 : 20 &gt; 12 , minimum = 12 <br />

Comparing with 23 : 12 &lt; 23 , minimum = 12 <br />

Comparing with 55 : 12  &lt; 55 , minimum = 12 <br />

Comparing with 21 : 12  &lt; 21 , minimum = 12</li>
<li>Place the minimum at the first position( index 0) of the array. <br />

Array =&#123; 12, 20 ,23, 55, 21&#125;</li>
<li>for the next iteration, start sorting from the first unsorted element i.e. the element next to where the minimum is placed.

Array = &#123;12, 20 ,23, 55, 21&#125;

Searching starts from 20, next element where minimum is placed.

Iteration 2 :

Minimum = 20

Comparing with 23 : 20 &gt; 23 , minimum = 20

Comparing with 55 : 20 &gt; 55 , minimum = 20

Comparing with 21 : 20 &gt; 21 , minimum = 20

Minimum in place no change,

Array = &123;12, 20 ,23, 55, 21&123;

Iteration 3 :

Minimum = 23.

Comparing with 55 : 23 &gt; 55 , minimum = 23

Comparing with 21 : 23 &lt; 21 , minimum = 21

Minimum is moved to index = 2

Array = &#123;12, 20, 21, 55, 23 &#125;

Iteration 4 :

Minimum = 55

Comparing with 23 : 23 &lt;55 , minimum = 23

Minimum in moved to index 3 Array = &#123;12, 20, 21, 23, 55&#125;</li>

            </ol>
            <div className='containers'>
           <code className='library'> #include</code>  &lt;stdio.h &gt;<br/>
           <code className='keywords'>int </code> main() <br /> &#123;<br/>
           <code className='keywords'> int</code>  arr[10]=&#123;6,12,0,18,11,99,55,45,34,2&#125;;<br/>
           <code className='keywords'> int</code>  n=10;<br/>
           <code className='keywords'> int</code>  i, j, position, swap;<br/>
           <code className='keywords'>for</code>  (i = 0; i  &lt; (n - 1); i++) &#123;<br/>
                   position = i;<br/>
           <code className='keywords'> for </code> (j = i + 1; j  &lt; n; j++) &#123;<br/>
           <code className='keywords'>   if</code>  (arr[position]  &gt; arr[j])<br/>
            position = j;<br/>
      &#125;<br/>
      <code className='keywords'>if</code>  (position != i) &#123;<br/>
         swap = arr[i];<br/>
         arr[i] = arr[position];<br/>
         arr[position] = swap;<br/>
      &#125;<br/>
   &#125;<br/>
   <code className='keywords'>for</code>  (i = 0; i  &lt; n; i++)<br/>
   <code className='library'>   printf</code> ("%d\t", arr[i]);<br/>
   <code className='library'> return</code> 0;<br/>
&#125;<br/>
            </div>
        </div>
    )
}

export default Thirty_four
